import React from 'react';
import autobind from 'autobind-decorator';
import { action, observable } from 'mobx';
import useLocalStorage from '../../../../hooks/useLocalStorage';
import Cookie from '../../../../common/utils/cookie';
import { ScoreService } from '../../../../common/services';

@autobind
class AbstractScoreCommon {
  localstorage = new useLocalStorage();

  @observable
  selectedGames = [];
  constructor() {
    this.selectedGames = this.localstorage.getItem('selectedGames') || [];
  }

  get login() {
    return !!Cookie.getCookie('session_id');
  }

  toggleInterestNavActive() {
    const interestNav = document.getElementById('interestNav');
    if (interestNav) {
      interestNav.classList.add('active');
      setTimeout(() => {
        interestNav.classList.remove('active');
      }, 200);
    }
  }

  @action
  async setSelectedGame(isSelected, id) {
    const { addKeyData, removeKeyData } = this.localstorage;

    if (this.login) {
      if (isSelected) {
        await ScoreService.deleteInterestGames([id]);
        this.selectedGames = this.selectedGames.filter(gameId => gameId !== id);
      } else {
        this.toggleInterestNavActive();
        await ScoreService.setInterestGames([id]);
        if (!this.selectedGames.includes(id)) {
          this.selectedGames = [...this.selectedGames, id];
        }
      }
    } else {
      if (isSelected) {
        removeKeyData('selectedGames', [id]);
      } else {
        this.toggleInterestNavActive();
        addKeyData('selectedGames', [id]);
      }

      this.selectedGames = this.localstorage.getItem('selectedGames') || [];
    }
  }

  @action
  async getFavoriteGames() {
    const { removeItem } = this.localstorage;
    let selectedGames = [];
    
    if (this.login) {
      const response = await ScoreService.getInterestGames(
        this.login,
        []
      );
      if(response){
        Object.values(response).map((typeValue) => {
          typeValue.map((match) => {
            selectedGames.push(match.id || match.gidx);
          });
        });
      }
      const localGames = this.localstorage.getItem('selectedGames') || [];
      if (localGames.length > 0) {
        const gamesToSync = localGames.filter(gameId => !selectedGames.includes(gameId));
        
        if (gamesToSync.length > 0) {
          await ScoreService.setInterestGames(gamesToSync);
          
          const updatedResponse = await ScoreService.getInterestGames(
            this.login,
            []
          );
          selectedGames = [];
          if(updatedResponse){
            Object.values(updatedResponse).map((typeValue) => {
              typeValue.map((match) => {
                selectedGames.push(match.id || match.gidx);
              });
            });
          }
        }
        removeItem('selectedGames');
      }
      if (!!selectedGames && selectedGames.length > 0) {
        this.selectedGames = selectedGames;
      } else {
        this.selectedGames = [];
      }
    } else {
      selectedGames = this.localstorage.getItem('selectedGames') || [];
      this.selectedGames = selectedGames;
    }
  }
}

export default AbstractScoreCommon;
